// extracted by mini-css-extract-plugin
module.exports = {"primaryCard":"ActionCardsContainer_primaryCard__v_M_J","dialog":"ActionCardsContainer_dialog__Mj_1j"};